import { computed } from 'vue';
export const isBrowser = typeof globalThis.window !== "undefined";
export const window = isBrowser ? globalThis.window : createWindow();
export const document = window.document;
export const navigator = window.navigator;
export const sessionStorage = isBrowser ? globalThis.sessionStorage : createStorage();
export const localStorage = isBrowser ? globalThis.localStorage : createStorage();
export const ios = isBrowser && /ip(hone|od|ad)/i.test(navigator.userAgent);
export const mobile = isBrowser &&
    (ios || navigator.userAgentData?.mobile ||
        /(android|webOS|mobile|BlackBerry|Opera Mini)/i.test(navigator.userAgent));
export const MOBILE_WIDTH = 719;
function createStorage() {
    return {
        length: 0,
        getItem: (key) => null,
        key: (index) => null,
        removeItem: (key) => null,
        clear: () => { },
        setItem: (key) => { }
    };
}
function createDocument() {
    const _document = {
        body: {},
        location: {
            hash: '',
            host: '',
            hostname: 'voice123.com',
            href: '',
            origin: '',
            pathname: '',
            protocol: '',
            search: '',
            replace: (url) => { }
        },
    };
    _document['createElement'] = () => ({
        children: [],
        childNodes: [],
        style: {},
        querySelector(args) { return null; },
        setAttribute() { },
        getElementsByTagName() {
            return [];
        },
    });
    return _document;
}
function createWindow() {
    const _document = createDocument();
    const _window = {
        location: _document.location,
        navigator: {
            userAgent: '',
        },
        document: _document,
    };
    _window['addEventListener'] = () => { };
    _window['removeEventListener'] = () => { };
    return _window;
}
export const isUnderMobileWidth = () => {
    const windowWidth = window.innerWidth;
    return windowWidth <= MOBILE_WIDTH;
};
export function isUnderMobileWidthSetup() {
    return computed(() => window.innerWidth < MOBILE_WIDTH);
}
;
export function toggleBodyScroll(blockScroll) {
    if (!isBrowser)
        return;
    const isSafariMobile = /(iPhone)/i.test(navigator.userAgent) &&
        !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    const bodyEl = document.body;
    if (blockScroll) {
        bodyEl.style.overflow = 'hidden';
        if (isSafariMobile) {
            const scrolledDistance = document.body.scrollTop || document.documentElement.scrollTop;
            bodyEl.style.position = 'fixed';
            bodyEl.style.top = `-${scrolledDistance}px`;
        }
    }
    else {
        bodyEl.style.overflow = 'scroll';
        if (isSafariMobile) {
            const scrolledDistance = bodyEl.style.top !== '0' ?
                Math.abs(parseInt(bodyEl.style.top.replace('px', ''), 10)) :
                0;
            bodyEl.style.top = '';
            bodyEl.style.position = '';
            bodyEl.scrollTop = scrolledDistance;
        }
    }
}
//# sourceMappingURL=browser.mjs.map